// removed by extract-text-webpack-plugin
module.exports = {"content":"src-pages----agb-module---content---xvC5c","AGB":"src-pages----agb-module---AGB---1ziUr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/agb.module.css
// module id = 392
// module chunks = 91699299032793